import { EntityPerspective } from '@/common/entityFramework/entityPerspective/EntityPerspective';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { useRef } from 'react';

export const AbvLbeItemPerspective = ({ lbeId }) => {
  const entityPerspectiveRef = useRef();
  const views = [
    {
      name: 'LBE Items',
      dims: ['LBE', 'PERIOD', 'CHANNEL', 'PROD'],
      kpis: ['GROSS_SALES', 'BASE_AMT', 'PRIOR_YEAR_BASE_AMT', 'TOTAL_BASE_AMT', 'PIPE_AMT'],
      disabledDims: ['LBE'],
      numFrozenDims: 1,
      dimToPeriodicities: {
        PERIOD: ['YEAR', 'QTR', 'MON'],
      },
    },
  ];

  const defaultDimFilters = { LBE: [lbeId] };

  const getContextMenuItems = (params) => {
    let contextMenus = entityPerspectiveRef.current.getContextMenuItems(params);

    let baseAmtSubMenu = [
      {
        name: 'Base Amount Transactions',
        action: () => entityPerspectiveRef.current.navigateToViewer(params, 'BASE_AMT', 'Base Amount Transactions'),
        icon: fas.faListUl,
      },
      {
        name: 'Prior Year Base Amount Transactions',
        action: () =>
          entityPerspectiveRef.current.navigateToViewer(
            params,
            'PRIOR_YEAR_BASE_AMT',
            'Prior Year Base Amount Transactions',
          ),
        icon: fas.faListUl,
      },
    ];

    let grossSalesSubMenu = [
      {
        name: 'Gross Sales Transactions',
        action: () => entityPerspectiveRef.current.navigateToViewer(params, 'GROSS_SALES', 'Gross Sales Transactions'),
        icon: fas.faListUl,
      },
    ];

    let pipelineSubMenu = [
      {
        name: 'Pipeline Transactions',
        action: () => entityPerspectiveRef.current.navigateToViewer(params, 'PIPE_AMT', 'Pipeline Transactions'),
        icon: fas.faListUl,
      },
    ];
    contextMenus.push(
      {
        name: 'Gross Sales',
        subMenu: grossSalesSubMenu,
        icon: fas.faListUl,
      },
      {
        name: 'Base Amounts',
        subMenu: baseAmtSubMenu,
        icon: fas.faListUl,
      },
      {
        name: 'Pipeline',
        subMenu: pipelineSubMenu,
        icon: fas.faListUl,
      },
    );
    return contextMenus;
  };

  return (
    <EntityPerspective
      ref={entityPerspectiveRef}
      entity={'LBE_ITEM'}
      gridOptions={{
        getContextMenuItems,
      }}
      defaultDimFilters={defaultDimFilters}
      views={views}
    />
  );
};
